import { BellOffIcon } from "lucide-react";

export function AllQuiet() {
  return (
    <div className="flex flex-col items-center justify-center gap-4 py-16 text-center">
      <div className="flex size-14 items-center justify-center rounded-2xl bg-muted">
        <BellOffIcon className="size-7 text-muted-foreground/40" />
      </div>
      <div>
        <p className="font-heading text-base font-semibold">All quiet — no signals in your log</p>
        <p className="mt-1 text-sm text-muted-foreground">
          Crew confirmations, safety alerts, and expedition updates will appear here.
        </p>
      </div>
    </div>
  );
}
